<template lang="pug">
    .component-selection-list
        .row
            .small-12.large-6.columns
                .wrapper(v-for="(i, index) in items", v-on:click="selectItem(index)")
                    component(:is="component", :item="i", :type="'list'")
            .small-12.large-6.columns
                component(:is="component", :item="selectedItem", :type="'expanded'", v-on:updated="updated")
</template>

<script type="text/babel">

    export default {
        name: "SelectionList",
        components: {},
        data: function () {
            return {
                selectedItem: null
            }
        },
        methods: {
            selectItem: function (index) {
                this.selectedItem = this.items[index]
            },
            updated: function(payload) {
                this.$emit("updated",payload);
            }
        },
        props: {
            component: Object,
            items: {
                type: Array,
                default: function () { return [] }
            }
        },
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .component-selection-list-item
        cursor: pointer
</style>



// WEBPACK FOOTER //
// SelectionList.vue?2e112e18